import React from "react";
import Token from "./Token";
import Coin from "./Coin";
import { useTranslation } from "react-i18next";

const Wallet = () => {
  const { t } = useTranslation();

  return (
    <div className="pages-wallet">
      <div className="title">{t("wallet.Wallet")}</div>
      <Coin />
      <Token />
    </div>
  );
};

export default Wallet;
